<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/contract/user/"
    :extra-params="{ contract_id: contractId, page_size: -1 }"
    :defaultTableOptions="{ itemsPerPage: -1 }"
    data-key="users"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    hide-default-footer
    class="contract-user-list"
  >
    <template #item.status="{ value }">
      <span :class="['user-status-span', value]">
        {{ value }}
        <div class="user-status-dot"></div>
      </span>
    </template>
    <template #item.updated_at="{ value }">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          text
          color="primary"
          v-if="item.managed_work_orders_count === 0 && canManageItem(item)"
          @click="deleteItem(item)"
        >
          DELETE
        </v-btn>
        <!--        <v-btn text-->
        <!--               color="primary"-->
        <!--               v-if="item.status === 'PENDING' || item.status === 'DECLINED'"-->
        <!--               @click="approveItem(item)">-->
        <!--          APPROVE-->
        <!--        </v-btn>-->
        <!--        <v-btn text-->
        <!--               color="primary"-->
        <!--               v-if="item.status === 'PENDING' || item.status === 'APPROVED'"-->
        <!--               @click="declineItem(item)">-->
        <!--          DECLINE-->
        <!--        </v-btn>-->
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE } from "@/constants";

export default {
  name: "ContractUserList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,

    contractId: String,
  },
  setup(props, { root, emit }) {
    const me = computed(() => root.$me());
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("contract_user.status"), value: "status", width: 150 },
      {
        text: root.$t("contract_user.name"),
        value: "account.name",
        width: 200,
      },
      { text: root.$t("contract_user.post"), value: "account.post" },
      { text: root.$t("contract_user.company"), value: "account.company" },
      {
        text: root.$t("contract_user.managed_work_orders_count"),
        value: "managed_work_orders_count",
      },
      { text: "", value: "actions", sortable: false, width: 250 },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({ name: "sor-detail", params: { sorId: item.id } });
    };
    const canManageItem = function (item) {
      return (
        ([USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].indexOf(me.value.type) !==
          -1 ||
          me.value.managed_contract_ids.indexOf(props.contractId) !== -1) &&
        item.account.id !== me.value.id
      );
    };
    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract_user.delete_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/user/delete/",
          params: { contract_user_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const approveItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract_user.approve_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/user/approve/",
          params: { contract_user_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const declineItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract_user.decline_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/user/decline/",
          params: { contract_user_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      canManageItem,
      deleteItem,
      approveItem,
      declineItem,
    };
  },
};
</script>

<style lang="less">
.contract-user-list {
  .user-status-span {
    .user-status-dot {
      height: 10px;
      width: 10px;
      border-radius: 10px;
      display: inline-block;
    }

    &.DECLINED {
      color: #ef3924;

      .user-status-dot {
        background-color: #ef3924;
      }
    }

    &.PENDING {
      color: #d4a106;

      .user-status-dot {
        background-color: #d4a106;
      }
    }

    &.APPROVED {
      color: #5bc23f;

      .user-status-dot {
        background-color: #5bc23f;
      }
    }
  }
}
</style>
